import { useSearchParams } from 'react-router-dom';
import ReceiptBreakdownReport from './ReceiptBreakdownReport';
import type { ReceiptReportType } from '@/types/reporte';

export default function ReceiptsReport() {
  const [searchParams, setSearchParams] = useSearchParams();
  const type: ReceiptReportType = searchParams.get('type')?.toUpperCase() === 'PROPIETARIO' ? 'PROPIETARIO' : 'INQUILINO';

  return <ReceiptBreakdownReport type={type} onTypeChange={nextType => {
    setSearchParams(previous => {
      const next = new URLSearchParams(previous);
      next.set('type', nextType.toLowerCase());
      return next;
    });
  }} />;
}
